import React from "react";
import { Link } from "react-router-dom";
import { Star } from "lucide-react";
import { Reveal, Label, SectionTitle } from "@/components/Reveal";
import { TESTIMONIALS } from "@/data/content";

export default function Testimonials() {
  return (
    <>
      <section className="pt-40 pb-12 text-center max-w-5xl mx-auto px-5">
        <Label>Testimonials</Label>
        <h1 className="text-5xl sm:text-6xl lg:text-7xl tracking-tighter mt-5">Words From Our Clients</h1>
        <p className="text-lg text-white/70 mt-6 max-w-2xl mx-auto">5-star experiences from brides, students and regulars across Bangalore.</p>
      </section>

      <section className="max-w-7xl mx-auto px-5 lg:px-8 pb-20">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {TESTIMONIALS.map((t, i) => (
            <Reveal key={t.name} delay={(i % 3) * 0.1}>
              <div className="glass rounded-lg p-8 h-full transition-colors duration-500" data-testid={`testimonial-${i}`}>
                <div className="flex gap-1 text-gold mb-4">{[...Array(5)].map((_, k) => <Star key={k} size={15} fill="#D4AF37" />)}</div>
                <p className="text-white/80 italic leading-relaxed">"{t.text}"</p>
                <div className="mt-6 pt-5 border-t border-white/10"><p className="text-gold">{t.name}</p><p className="text-white/50 text-xs">{t.role}</p></div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="py-16 text-center"><Link to="/book" className="btn-gold" data-testid="testimonials-cta">Book Your Experience</Link></section>
    </>
  );
}
